import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom'
import { Application } from '@yulintu/freesia-bootstrap';
import { URIUtil } from 'freesia-core'

export default function MainEntry(props) {
    const appContext = useContext(Application.Context);
    const lo = useLocation();
    const backUrl = lo?.query?.backUrl;
    const ssoSiteUrl = appContext?.config?.ssoSiteUrl
    const platform = appContext?.config?.platform
    const platform_key = appContext?.config?.platform_key

    useEffect(() => {
        if (backUrl && ssoSiteUrl) {
            const newBackUrl = URIUtil.appendParams(backUrl, {
                platform,
                platform_key
            });
            window.location.href = `${ssoSiteUrl}?backUrl=${encodeURIComponent(newBackUrl)}`
        }
    }, [backUrl, ssoSiteUrl, platform, platform_key])
    return null;
}